import React from 'react';
import Seo from '../components/Seo';
import HeroSection from '../components/HeroSection';

const HomePage = () => {
  return (
    <>
      <Seo
        title="CenterSoftech"
        description="Building things for phones and the web."
        path="/"
      />
      <HeroSection />
    </>
  );
};

export default HomePage;
